import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import {of as observableOf,  Observable } from 'rxjs';
import {catchError} from 'rxjs/operators';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/response';
import { IClientSecret, IPublicApiClients } from './publicapiclients-model';

@Injectable()
export class PublicApiClientsService {
    constructor(
        private http: HttpClient
    ) { }

    private static get URL(): string { return `${environment.dashboardApi.baseUrl}${environment.dashboardApi.prefix}`; }
    private static readonly ENDPOINT = 'publicapiclients/{clientId}';

    /** GET */
    public getClients(tenatId: string): Observable<SuccessResponse<IPublicApiClients> | ErrorResponse>  {
        return this.http
            .get<SuccessResponse<IPublicApiClients>>(
                PublicApiClientsService.URL +
                'publicapiclients',
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    /** POST */
    public addClient(): Observable<SuccessResponse<IClientSecret> | ErrorResponse>  {
        return this.http
            .post<SuccessResponse<IClientSecret>>(
                PublicApiClientsService.URL +
                'publicapiclients',
                null
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    /** DELETE */
    public deleteClient(clientId: string): Observable<SuccessResponse<boolean> | ErrorResponse>  {
        return this.http
            .delete<SuccessResponse<boolean>>(
                PublicApiClientsService.URL +
                PublicApiClientsService.ENDPOINT.replace('{clientId}', clientId)
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }
}
